export default __webpack_public_path__ + "static/25-37858b01eaac8b6dd12372b2efa298c2.png";